var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 -18 40 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0H5C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5V45C0 46.3261 0.526784 47.5979 1.46447 48.5355C2.40215 49.4732 3.67392 50 5 50H35C36.3261 50 37.5979 49.4732 38.5355 48.5355C39.4732 47.5979 40 46.3261 40 45V15L25 0ZM13.745 35.475C12.9725 36.2 11.8325 36.525 10.505 36.525C10.2476 36.5278 9.99032 36.5128 9.735 36.48V40.045H7.5V30.205C8.50864 30.0545 9.5278 29.986 10.5475 30C11.94 30 12.93 30.265 13.5975 30.7975C14.2325 31.3025 14.6625 32.13 14.6625 33.105C14.66 34.085 14.335 34.9125 13.745 35.475ZM23.2625 38.8625C22.2125 39.735 20.615 40.15 18.6625 40.15C17.4925 40.15 16.665 40.075 16.1025 40V30.2075C17.1115 30.0602 18.1303 29.9909 19.15 30C21.0425 30 22.2725 30.34 23.2325 31.065C24.27 31.835 24.92 33.0625 24.92 34.825C24.92 36.7325 24.2225 38.05 23.2625 38.8625ZM32.5 31.925H28.67V34.2025H32.25V36.0375H28.67V40.0475H26.405V30.075H32.5V31.925ZM25 17.5H22.5V5L35 17.5H25Z",
    fill: "#808285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.6a320b30e126f63ca4fe6fbdc501dd05.svg";
export { ForwardRef as ReactComponent };